import { lazy } from 'react';
import Patient from '../pages/patient/Patient';

const ReportsPage = lazy(() => import('../pages/Reports.page'));
const CheckUpPage = lazy(() => import('../pages/checkup/CheckUp'));
const ReportsFinancePage = lazy(() => import('../pages/finance/Finance'));

export const ReportsRoutes = [
    { path: 'reports', element: <ReportsPage /> },
    {
        path: '/reports/patient',
        element: <Patient />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/checkup',
        element: <CheckUpPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/finance',
        element: <ReportsFinancePage />,
        layout: 'default',
        isAuthReq: true,
    },
];
